import once from './once';
export const getHasSharedWorkerSupport = once(
// eslint-disable-next-line compat/compat
() => Boolean(window.SharedWorker) && Boolean(window.BroadcastChannel));